

export class UserTypeOutputWithoutStatus implements IUserTypeOutputWithoutStatus {
    /** The auto-generated id of the user type master */
    user_type_id!: number;
    /** The user type code with 255 character limit */
    user_type_code!: string;
    /** The user type code with 255 character limit */
    user_type_name!: string;

    constructor(data?: IUserTypeOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_type_id = _data["user_type_id"];
            this.user_type_code = _data["user_type_code"];
            this.user_type_name = _data["user_type_name"];
        }
    }

    static fromJS(data: any): UserTypeOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_type_id"] = this.user_type_id;
        data["user_type_code"] = this.user_type_code;
        data["user_type_name"] = this.user_type_name;
        return data; 
    }
}

export interface IUserTypeOutputWithoutStatus {
    /** The auto-generated id of the user type master */
    user_type_id: number;
    /** The user type code with 255 character limit */
    user_type_code: string;
    /** The user type code with 255 character limit */
    user_type_name: string;
}

